module.exports = __webpack_public_path__ + "static/media/so1.4bee9815.ico";